import { Box, Stack, Typography } from "@mui/material";
import { AppLayout } from "../../../containers/layout/app";
import { UnauthorizedErrorWrapper } from "./styled";
import unauthorizedIcon from "../../../assets/images/unauthorizedimg.svg";
import { BaseButton } from "../../../components/button/styled";
import { useNavigate } from "react-router-dom";

export const UnauthorizedError = () => {
	const navigate = useNavigate();

	const handleNavigateToDashboard = (
		e: React.MouseEvent<HTMLButtonElement, MouseEvent>
	) => {
		e.preventDefault();
		navigate("/dashboard");
	};

	return (
		<AppLayout pageId={"Error"} pageTitle={"Unauthorized"}>
			<UnauthorizedErrorWrapper>
				<Box component={"div"} className="icon-box">
					<img src={unauthorizedIcon} alt="Unauthorized Icon" />
				</Box>
				<Stack gap={"calc(var(--flex-gap)/4)"}>
					<Box component={"div"} className="header-box">
						<Typography
							variant="h2"
							fontFamily={"Poppins"}
							fontWeight={700}
							fontSize={24}
							lineHeight={"normal"}
							color="var(--midnight-blue-color)"
							whiteSpace={"normal"}
							textAlign={"center"}
						>
							You’re not Authorized to access this page.
						</Typography>
					</Box>
					<Box component={"div"} className="body-box">
						<Typography
							variant="body1"
							fontFamily={"Inter"}
							fontWeight={500}
							fontSize={16}
							lineHeight={"normal"}
							color="var(--semi-dark-color)"
							textAlign={"center"}
							whiteSpace={"normal"}
						>
							Please contact the administrator.
						</Typography>
					</Box>
				</Stack>
				<Box component={"div"} className="call-to-action-box">
					<BaseButton
						variant="contained"
						bgcolor="var(--primary-color)"
						disableElevation
						sx={{
							width: { mobile: "100%", miniTablet: "auto" },
						}}
						onClick={handleNavigateToDashboard}
					>
						<Typography
							variant={"button"}
							fontFamily={"inherit"}
							fontWeight={"inherit"}
							fontSize={"inherit"}
							lineHeight={"inherit"}
							color={"inherit"}
							textTransform={"inherit"}
						>
							Return to Dashboard
						</Typography>
					</BaseButton>
				</Box>
			</UnauthorizedErrorWrapper>
		</AppLayout>
	);
};
